import styled from '@emotion/styled';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import ResourceMarkdown from '../details/ResourceMarkdown';

export default function OrgDocumentationPageContent() {
    const { currentOrg } = useCurrentOrgDetailsFetching();

    if (!currentOrg) return null;
    return (
        <>
            {currentOrg.customResourcesMarkdown && <ResourceMarkdown markdown={currentOrg.customResourcesMarkdown} />}
            {currentOrg.customResourcesMarkdown && currentOrg.managedResourcesMarkdown && <Break />}
            {currentOrg.managedResourcesMarkdown && <ResourceMarkdown markdown={currentOrg.managedResourcesMarkdown} />}
        </>
    );
}

const Break = styled.div`
    margin: 0;
    border-radius: 10px;
    border-top: 6px solid ${({ theme }) => theme.color.text};
    width: 100%;
`;
